module.exports = __webpack_public_path__ + "img/login_bsgs_slogan.3256ce65.svg";